import { render, staticRenderFns } from "./EnduserMyAgenda.vue?vue&type=template&id=87c0587a&"
import script from "./EnduserMyAgenda.vue?vue&type=script&lang=js&"
export * from "./EnduserMyAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports